import React, { createRef, useContext, useImperativeHandle } from 'react';
import { Chat } from './components/Chat';
import { useSendMessage } from './hooks';
import {
	frameStateContext,
	IFrameStateCallback,
} from './contexts/frame/context';
import { AppProvider, IAppProviderProps } from './AppProvider';

export type IAPIComponentRef = {
	toggleChat: IFrameStateCallback['toggleChat'];
	sendMessage: (
		data: Parameters<ReturnType<typeof useSendMessage>>[0],
	) => Promise<string>;
};
const APIComponent = React.forwardRef<IAPIComponentRef, {}>(
	function API(_, ref) {
		// used to expose toggleChat as API
		const { toggleChat } = useContext(frameStateContext);
		const sendMessage = useSendMessage();
		const _ref = ref ?? createRef();
		useImperativeHandle(
			_ref,
			() => ({
				toggleChat,
				sendMessage: (data) => sendMessage(data, true),
			}),
			[toggleChat, sendMessage],
		);
		return null;
	},
);

export const App = React.forwardRef(
	(
		{ instance, configuration, apiProps, baseUrl }: IAppProviderProps,
		ref: React.ForwardedRef<IAPIComponentRef>,
	) => {
		return (
			<AppProvider
				configuration={configuration}
				instance={instance}
				apiProps={apiProps}
				baseUrl={baseUrl}
			>
				<APIComponent ref={ref} />
				<Chat />
			</AppProvider>

			// <ReduxProvider>
			// 	<ChatConfigurationProvider
			// 		configuration={configuration}
			// 		fetchConfiguration={fetchConfiguration}
			// 		provider={provider}
			// 		notificationEnabled={!disableNotification}
			// 		baseUrl={baseUrl}
			// 	>
			// 		<ErrorBoundary id="app">
			// 			<GenericProvider>
			// 				<FrameStateProvider
			// 					isOpen={isOpen}
			// 					page={page}
			// 					onMaximize={onMaximize}
			// 					onMinimize={onMinimize}
			// 					isStandalone={isStandalone}
			// 					hidePopup={hidePopup}
			// 					isFullscreen={isFullscreen}
			// 					isDetached={isDetached}
			// 				>
			// 					<IntlProvider>
			// 						<NotificationProvider>
			// 							<ChatInitProvider
			// 								{...{
			// 									params,
			// 									onConnection,
			// 									onPostMessage,
			// 								}}
			// 							>
			// 								<APIComponent ref={ref} />
			// 								<Chat />
			// 							</ChatInitProvider>
			// 						</NotificationProvider>
			// 					</IntlProvider>
			// 				</FrameStateProvider>
			// 			</GenericProvider>
			// 		</ErrorBoundary>
			// 	</ChatConfigurationProvider>
			// </ReduxProvider>
		);
	},
);
